export const SEND_RFQ_EMAIL_REQUEST = "SEND_RFQ_EMAIL_REQUEST";
export const SEND_RFQ_EMAIL_SUCCESS = "SEND_RFQ_EMAIL_SUCCESS";
export const SEND_RFQ_EMAIL_FAILED = "SEND_RFQ_EMAIL_FAILED";

export const REQUEST_FREE_SUPPLIER_LIST = "REQUEST_FREE_SUPPLIER_LIST";
export const SUCCESS_FREE_SUPPLIER_LIST = "SUCCESS_FREE_SUPPLIER_LIST";
export const FAILED_FREE_SUPPLIER_LIST = "FAILED_FREE_SUPPLIER_LIST";